import * as React from "react";
import Contact from "../components/Contact";
import Layout from "../components/Layout";
import Table from "../components/Table";
import leaseIpv4 from '../lease-ipv4.json';
import TextBlock from "../components/TextBlock";
var Page = function Page() {
    return /*#__PURE__*/ React.createElement(Layout, {
        title: "Lease IPv4",
        description: ""
    }, /*#__PURE__*/ React.createElement(TextBlock, {
        background: "/images/bg-lease-ipv4.jpg",
        backgroundColor: "#070b2c",
        color: "#ffffff",
        title: "Lease IPv4"
    }, "IPv4 addresses are becoming more and more expensive and may make more sense to your company to lease IPv4 address space instead of buying them. We have clients offering IPv4 addresses for short- and long-term rental, In addition, we also have our own stock of IPv4 addresses. In this way, IPv4 addresses are available for every business, extra-small, small or large. Interested in leasing IPv4 addresses or IPV4 address space? We will inform you about the possibilities we offer."), /*#__PURE__*/ React.createElement(TextBlock, {
        title: "Advantages of IPv4 Leasing",
        h1: false
    }, "The advantage of IPv4 lease are the prices and  the availability to use them almost immediately. Sometimes the best possible solution is to lease, because you pay a specific price per month instead of paying a large amount of money one time. We would like  to help achieve your goals by offering IPv4 for lease with our network."), /*#__PURE__*/ React.createElement(TextBlock, {
        background: "/images/bg-lease-ipv4-2.jpg",
        backgroundColor: "#070b2c",
        color: "#ffffff",
        h1: false,
        title: "Why lease with us?"
    }, "Why you should choose us to lease IPv4 addresses? We have a lot of lease opportunities so you can rent the IP addresses for as long as you need them. We know how to coordinate safe lease agreements. Besides that we have experts that can help you with leasing IPv4 addresses. In a professional way we connect buyers and sellers, so both parties will be satisfied in the end. We deliver Letter LOA, Create Object Route Etc.."), /*#__PURE__*/ React.createElement(Table, {
        title: "Available Prefixes",
        head: ['Prefix', 'Available', 'Pricing'],
        data: leaseIpv4
    }), /*#__PURE__*/ React.createElement(Contact, null, "Do you have any ", /*#__PURE__*/ React.createElement("strong", null, "Questions"), "?. Do you need to ", /*#__PURE__*/ React.createElement("strong", null, "lease IPv4 addresses"), " with us?"));
};
export default Page;
